import React, { Component } from 'react';
import './App.css';
import GameList from './GameList/GameList.js';
import Login from './Security/Login.js';
import UserRanking from "./Ranking/UserRanking";
import RankingList from './Ranking/RankingList';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import './Tabs.css';
import { FormattedMessage } from 'react-intl';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: {}
        }
    }

    // set user state from anywhere
    setUserState = (data) =>  {
        this.setState({
            user: data
        })
    };

    render() {
        let content = null;
        if (this.state.user && this.state.user.uid) {
            content =
                <div>
                    <Tabs forceRenderTabPanel={true}>
                        <TabList>
                            <Tab><FormattedMessage id={ 'tabs.info.title' } defaultMessage={ 'Info' } /></Tab>
                            <Tab><FormattedMessage id={ 'tabs.next_games.title' } defaultMessage={ 'Nächste Spiele' } /></Tab>
                            <Tab><FormattedMessage id={ 'tabs.ranking.title' } defaultMessage={ 'Rangliste' } /></Tab>
                        </TabList>

                        <TabPanel>
                            <UserRanking user={ this.state.user } />
                        </TabPanel>
                        <TabPanel>
                            <GameList user={this.state.user} locale={this.props.locale} />
                        </TabPanel>
                        <TabPanel>
                            <RankingList user={this.state.user} locale={this.props.locale} />
                        </TabPanel>
                    </Tabs>
                </div>;
        } else {
            content =
                <Tabs forceRenderTabPanel={true}>
                    <TabList>
                        <Tab><FormattedMessage id={ 'tabs.initial.title' } defaultMessage={ 'Tippspiel' } /></Tab>
                    </TabList>

                    <TabPanel>
                        <Login setUserState={this.setUserState} />
                    </TabPanel>

                </Tabs>
                ;
        }
        return (
            <div className="App">
                {content}
            </div>
        );

    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js